// Global backend URL (set via Vite environment variable)
//export const backendUrl = import.meta.env.VITE_BACKEND_URL
export const backendUrl = process.env.VITE_BACKEND_URL || "https://jfkbe-4zre.onrender.com";
